module.exports = __webpack_public_path__ + "static/media/comment-alt-slash.2e769f7e.svg";